import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MarketingState } from './marketing.reducer';

export const selectMarketingState = createFeatureSelector<MarketingState>('marketing');

export const selectMarketingReport = createSelector(
  selectMarketingState,
  (state: MarketingState) => state.report
);

export const selectMarketingLoading = createSelector(
  selectMarketingState,
  (state: MarketingState) => state.loading
);

export const selectMarketingError = createSelector(
  selectMarketingState,
  (state: MarketingState) => state.error
);

export const selectCompanyData = createSelector(
  selectMarketingReport,
  (report) => report?.data?.report_metadata || null
);

export const selectCompetitors = createSelector(
  selectMarketingReport,
  (report) => report?.data?.industry_snapshot || null
);

export const selectTrends = createSelector(
  selectMarketingReport,
  (report) => report?.data?.trend_analysis || null
);

export const selectRecommendations = createSelector(
  selectMarketingReport,
  (report) => []
);

export const selectLeadMagnetState = createSelector(
  selectMarketingState,
  (state: MarketingState) => state.leadMagnet
);

export const selectLeadMagnetResponse = createSelector(
  selectLeadMagnetState,
  (leadMagnetState) => leadMagnetState.response
);

export const selectLeadMagnetLoading = createSelector(
  selectLeadMagnetState,
  (leadMagnetState) => leadMagnetState.loading
);

export const selectLeadMagnetError = createSelector(
  selectLeadMagnetState,
  (leadMagnetState) => leadMagnetState.error
);